const state = {
    language: "中文",
    data: {
        title: "",
        name: "",
        desc1: "",
        desc2: "",
        isShow: false
    }
};

const getters = {
    getType: state => state.language,
    getdata: state => state.data
};

const mutations = {
    changelanguage(state, language) {
        state.language = language;
        localStorage.setItem("language", language);
    },
    changeModel(state, data) {
        state.data = data;
    },
    hidemodel(state, data) {
        state.data.isShow = data.isShow;
    }
};

export default {
    state,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/home.js